"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Hint = _interopRequireDefault(require("../Hint"));

var _cvv_hint = _interopRequireDefault(require("./img/cvv_hint.png"));

var _l10n = _interopRequireDefault(require("../../common/l10n"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _root = _interopRequireDefault(require("./style/hint/root"));

var _label = _interopRequireDefault(require("./style/hint/label"));

var CvvHint = function CvvHint(_ref) {
  var label = _ref.label,
      children = _ref.children,
      position = _ref.position,
      theme = _ref.theme;
  return _react["default"].createElement(_Hint["default"], {
    label: _react["default"].createElement(_root["default"], {
      theme: theme
    }, _react["default"].createElement(_label["default"], {
      theme: theme
    }, _l10n["default"].t(label)), _react["default"].createElement("br", null), _react["default"].createElement("img", {
      src: _cvv_hint["default"],
      width: 220,
      alt: "CVV"
    })),
    position: position,
    wide: true
  }, children);
};

CvvHint.defaultProps = {
  position: 'right-bottom',
  label: 'DEBIT_SOURCE_CARD_HINT_CVV'
};
CvvHint.propTypes = {
  position: _propTypes["default"].string,
  label: _propTypes["default"].string,
  children: _propTypes["default"].any
};
var _default = CvvHint;
exports["default"] = _default;